module.exports = __webpack_public_path__ + "static/media/VIIh.14c3798f.jpg";